'use strict';

var keys = Object.keys;

module.exports = function (object) {
	return keys(object == null ? object : Object(object));
};



//////////////////
// WEBPACK FOOTER
// ./~/event-emitter/~/es5-ext/object/keys/shim.js
// module id = 22
// module chunks = 0